"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Callout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const Flex_1 = require("./Flex");
const Icon_1 = require("./Icon");
const intent_1 = require("../constants/intent");
const theme_1 = require("../constants/theme");
const utils_1 = require("../utils");
const CalloutComponent = styled_1.default.div((props) => {
    return {
        alignItems: 'flex-start',
        backgroundColor: props.backgroundColor,
        borderRadius: theme_1.theme.border.radius.normal,
        color: props.color,
        display: 'flex',
        fontSize: props.size === 'sm' ? theme_1.theme.font.size[6] : undefined,
        lineHeight: theme_1.theme.lineHeight.relaxed,
        padding: theme_1.theme.spacing[3],
        ...(0, utils_1.createStyles)(props.styles),
    };
});
const Content = styled_1.default.div((props) => ({
    // Manual alignment with icon:
    marginTop: props.size === 'sm' ? 1 : 0,
    width: '100%',
}));
const Callout = (props) => {
    const { backgroundColor, color, iconName } = (0, intent_1.getIntentProps)(props.intent);
    return ((0, jsx_runtime_1.jsx)(CalloutComponent, { backgroundColor: backgroundColor, className: props.className, color: color, size: props.size, styles: props.styles, children: (0, jsx_runtime_1.jsxs)(Flex_1.Flex, { gap: 2.5, styles: { width: '100%' }, children: [props.icon !== null && ((0, jsx_runtime_1.jsx)(Icon_1.Icon, { color: color, name: props.icon ?? iconName })), (0, jsx_runtime_1.jsx)(Content, { size: props.size, children: props.children })] }) }));
};
exports.Callout = Callout;
